import { initContract } from '@ts-rest/core'
import { authContract } from './auth'
import { courierContract } from './courier'
import { entitiesContract } from './entities'
import { fulfillmentContract } from './fulfillment'
import { orderContract } from './order'
import { paymentContract } from './payment'
import { productContract } from './product'
import { subscriptionContract } from './subscription'
import { animalsContract } from './users/animal'

export type { ErrorResponse } from './general'

const c = initContract()

export const contract = c.router({
  auth: authContract,
  entities: entitiesContract,
  fulfillment: fulfillmentContract,
  courier: courierContract,
  product: productContract,
  subscription: subscriptionContract,
  order: orderContract,
  payment: paymentContract,
  animals: animalsContract,
})

export {
  animalsContract,
  authContract,
  courierContract,
  entitiesContract,
  fulfillmentContract,
  orderContract,
  paymentContract,
  productContract,
  subscriptionContract
}
